import { z } from "zod";
import { PriceStatusSchema } from "./primitives.js";
export const SavingsAmountSchema = z.object({
    amountCents: z.number().int(),
    currency: z.literal("EUR"),
    status: PriceStatusSchema,
});
// GET /v1/insights/value response
export const InsightsResponseSchema = z.object({
    hasData: z.boolean().describe("False renders the honest empty state, never €0-as-certainty."),
    realized: SavingsAmountSchema.nullable(),
    projected: SavingsAmountSchema.nullable(),
    adherence: z
        .object({
        mealsPlanned: z.number().int().nonnegative(),
        outcomesRecorded: z.number().int().nonnegative(),
        adherenceRatePercent: z.number().min(0).max(100),
    })
        .nullable(),
    timeSavedMinutes: z.number().int().nullable(),
    /**
     * ADR-028 Phase 2 / PRD §7.10 ("separates ... pantry/leftover, offer ...
     * savings so totals are not duplicated"): realized savings per
     * savings_events kind in integer cents, e.g. { pantry_reuse: 850, offer:
     * 390 }. Extensible record keyed by kind; only kinds with a non-zero
     * realized sum appear, the values sum to `realized.amountCents`, and the
     * field is null exactly when `realized` is null (honest empty state).
     */
    byKind: z.record(z.string(), z.number().int().nonnegative()).nullable(),
});
//# sourceMappingURL=insights.js.map